import React, { useState } from 'react';
import { Modal, Button, Form, Card } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';

function VariableModal({ show, onHide, availableVariables, runbookVariables, onAddVariable, onRemoveVariable }) {
  const [selectedVariableId, setSelectedVariableId] = useState('');

  const handleAddVariable = () => {
    if (selectedVariableId) {
      const variable = availableVariables.find(v => v.variableId === selectedVariableId);
      if (variable) {
        onAddVariable(variable);
        setSelectedVariableId('');
      }
    }
  };

  // Filter out variables already added to the runbook
  const availableToAdd = availableVariables.filter(
    av => !runbookVariables.find(rv => rv.variableId === av.variableId)
  );

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Manage Runbook Variables</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Currently Added Variables */}
        {runbookVariables.length > 0 && (
          <div className="mb-4">
            <h6 className="small fw-bold mb-2">Added to Runbook</h6>
            {runbookVariables.map((variable) => (
              <Card key={variable.variableId} className="mb-2 border">
                <Card.Body className="p-2 d-flex justify-content-between align-items-center">
                  <div>
                    <div className="fw-bold small">{variable.variableNumber} - {variable.variableName}</div>
                    <div className="text-muted" style={{ fontSize: '0.7rem' }}>
                      ID: {variable.variableId}
                    </div>
                  </div>
                  <Button
                    variant="link"
                    size="sm"
                    className="text-danger p-0"
                    onClick={() => onRemoveVariable(variable.variableId)}
                  >
                    <FaTrash />
                  </Button>
                </Card.Body>
              </Card>
            ))}
          </div>
        )}

        {/* Add Variable Section */}
        <div>
          <h6 className="small fw-bold mb-2">Add Variable to Runbook</h6>
          {availableToAdd.length > 0 ? (
            <>
              <Form.Group className="mb-3">
                <Form.Select
                  size="sm"
                  value={selectedVariableId}
                  onChange={(e) => setSelectedVariableId(e.target.value)}
                >
                  <option value="">Select a variable...</option>
                  {availableToAdd.map((variable) => (
                    <option key={variable.variableId} value={variable.variableId}>
                      {variable.variableNumber} - {variable.variableName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Button
                variant="primary"
                size="sm"
                className="w-100"
                onClick={handleAddVariable}
                disabled={!selectedVariableId}
              >
                <FaPlus className="me-1" /> Add to Runbook
              </Button>
            </>
          ) : (
            <div className="text-muted small text-center py-3">
              {availableVariables.length === 0
                ? "No variables available. Please create variables in My Variables first."
                : "All available variables have been added to this runbook."}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VariableModal;
